




































































import {Component, PropSync, Watch} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import BaseFilter from '@/components/Filter/BaseFilter';
import {SystemUserFilter} from '@/store/user_management/system_users/types';
import {SelectWings, ToggleWings, InputWings} from 'wings-ui-components';
import { UserRoleItem } from '@/store/user_management/roles/types';
import { notifyError } from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class SystemUsersFilter extends BaseFilter<SystemUserFilter> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;

  @Action('getUserRoles') actionGetUserRoles: any;
  @Action('getSystemUsers') actionGetItems: any;
  @Action('exportSystemUsers') actionExport: any;

  @Getter('userRoles') userRolesList!: UserRoleItem[];

  statusList: number[] = [1,0];
  filterKeys: object = {
    "role_name" : "role"
  }

  defaultFilter(): SystemUserFilter {
    return {
      name: undefined,
      email: undefined,
      role_name: undefined,
      status: undefined,
      page_number: 1
    };
  }

  async created() {
    try {
      this.actionGetUserRoles();
      this.filtered();
      this.scroll();
    } catch (error) {
      notifyError(error);
    }
  }

  // Override BaseFilter.doActionExport
  // async doActionExport(filter: SystemUserFilter): Promise<any> {
  //   return await this.actionExport(filter);
  // }
  export(): void {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "System account",
      addititional_info: getTranslatedParams(this.filter, this.filterKeys)
    }
    this.actionExport(this.filter).then(()=>{
      this.actionLog(this.logObject);
    }).catch((error: any) => {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    });
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "System account",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      }
      const resp = await this.actionGetItems({ ...this.filter, ...{ is_ad_user: 0 } });
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: SystemUserFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
